import React from "react";
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  AlertColor,
  Alert,
  Snackbar,
} from "@mui/material";
import { DoorData } from "./DoorSettingsPage";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import { useState } from "react";

interface BasicSettingsProps {
  doorData: DoorData | undefined;
}

const BasicSettings: React.FC<BasicSettingsProps> = ({ doorData }) => {
  // アラート
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("success");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    // window.location.reload();//下部アラートが消えた後に画面リロード
  };

  const handleOpen = async () => {
    if (doorData && doorData.sdcUuid) {
      try {
        // call openDoor API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT +
          `/sdc/${doorData.sdcUuid}/open-door`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: await getJwtTokenFromIdToken(),
            },
            body: JSON.stringify({}),
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          setSnackbarMessage("ドアを開きました。");
          setAlertSeverity("success");
          setSnackbarOpen(true);
        }
      } catch (e) {
        console.error("Error open door:", e);
        setSnackbarMessage("ドアの開を失敗しました。");
        setAlertSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row" colSpan={2}>
                  <Typography variant="h6">ドア制御</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>手動開閉:</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleOpen}
                  >
                    解錠・開放
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={alertSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default BasicSettings;
